const t = {
  name: "Wallet",
  dimensions: { width: 22, height: 18 },
  content: `
    <path d="M19 13V15C19 16.1 18.19 17 17.2 17H2.8C1.81 17 1 16.1 1 15V3C1 1.9 1.81 1 2.8 1H17.2C18.19 1 19 1.9 19 3V5" fill="none" stroke="currentColor"  stroke-width="2" stroke-miterlimit="10"/>
    <path d="M19 13H14C11.79 13 10 11.21 10 9C10 6.79 11.79 5 14 5H19C20.1 5 21 5.9 21 7V11C21 12.1 20.1 13 19 13Z" fill="none" stroke="currentColor"  stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14 10C14.5523 10 15 9.55228 15 9C15 8.44772 14.5523 8 14 8C13.4477 8 13 8.44772 13 9C13 9.55228 13.4477 10 14 10Z" fill="currentColor" stroke="none"/>
  `
};
export {
  t as Wallet
};
